import { CommonModule } from '@angular/common';
import { Component, Input, computed, inject } from '@angular/core';
import { UIService } from '@shared/utils';
import packageInfo from '@root/package.json';
import { WrapperComponent } from '@shared/ui/components';
import { DividerModule } from 'primeng/divider';

@Component({
  standalone: true,
  selector: 'reza-footer',
  imports: [CommonModule, DividerModule, WrapperComponent],
  template: `
    <div class="footer">
      <div class="flex justify-content-between align-items-center p-1">
        <div class="prohlaseni-o-zpracovani-osobnich-udaju">
          <span *ngIf="publicFooter">
            {{ currentYear }} © DIA • Informace jsou poskytovány v souladu se zákonem č. 106/1999 Sb., o svobodném
            přístupu k informacím.
          </span>
          <a href="https://www.dia.gov.cz/" class="underline">
            Digitální a informační agentura - Startujeme digitalizaci Česka | Digitální Transformace (gov.cz)
          </a>
        </div>

        <div>
          <span>Verze: {{ version() }}</span>
        </div>
      </div>
    </div>
  `,

  styles: [
    `
      a {
        text-align: right;
        color: #ffffff;
        padding: 0px 10px;
      }
      div {
        font-size: 96%;
      }
      span {
        padding: 0px 10px;
      }

      .prohlaseni-o-zpracovani-osobnich-udaju {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
    `,
  ],
})
export class FooterComponent {
  @Input()
  publicFooter = false;

  readonly uiService = inject(UIService);
  currentYear = new Date().getFullYear();

  readonly version = computed(() => {
    if (this.uiService.isProdEnv) {
      return this.getProductionVersion(packageInfo.version);
    } else {
      return packageInfo.version;
    }
  });

  private getProductionVersion(version: string): string {
    // Rozdělení verze na části pomocí tečky a pomlčky
    const parts = version.split(/[.-]/);

    // Vrácení prvních dvou částí (major a minor verze)
    return `${parts[0]}.${parts[1]}`;
  }
}
